import React from 'react';
import {style, classes} from './inline-ltr-text.st.css';

export const InlineLtrText = React.memo(function InlineLtrText (props: InlineLtrText.Props) {
    const {
        children,

        className,
        ...htmlAttributes
    } = props;

    return (
        <span
            {...htmlAttributes}
            className={style(classes.root, className)}
            dir={'ltr'}
        >
            {children}
        </span>
    );
});

export namespace InlineLtrText {

    export interface Props extends React.HTMLAttributes<any> {
        children: string;
    }
}
